import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import Dismiss from '../__partials/dismiss';
import Headline from '../type/headline';
import classNames from 'classnames';

import './style.scss';

const Overlay = ({
  environment = 'light',
  isOpen,
  allowCloseOnOverlayClick = true,
  allowCloseOnEsc = true,
  parentSelector,
  title,
  children,
  label = 'Hudl Overlay',
  className,
  style,
  qaId,
  onAfterOpen,
  onClose,
}) => {
  let overlayContentRef;
  const handleAfterOpenAction = () => {
    setTimeout(() => {
      if (!onAfterOpen) {
        overlayContentRef && overlayContentRef.focus();
      } else {
        onAfterOpen();
      }
    }, 300);
  };

  const overlayClasses = classNames('uni-overlay__scrim', {
    [`uni-env--${environment}`]: environment,
  });
  const overlayBodyClasses = classNames('uni-overlay', className);

  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={allowCloseOnOverlayClick}
      shouldCloseOnEsc={allowCloseOnEsc}
      onRequestClose={onClose}
      onAfterOpen={handleAfterOpenAction}
      contentLabel={label}
      role="dialog"
      portalClassName="uni-overlay__portal"
      overlayClassName={{
        base: overlayClasses,
        afterOpen: 'uni-overlay__scrim--is-visible',
        beforeClose: 'uni-overlay__scrim--is-hidden',
      }}
      bodyOpenClassName="uni-overlay__body--is-open"
      className={{
        base: overlayBodyClasses,
        afterOpen: '',
        beforeClose: '',
      }}
      style={style}
      parentSelector={parentSelector}
      closeTimeoutMS={500}
      aria={{
        labelledby: 'overlayTitle',
        describedby: 'overlayContent',
      }}
      shouldFocusAfterRender
      ariaHideApp={false}
      contentRef={el => {
        overlayContentRef = el;
      }}
      data={{
        'qa-id': qaId,
      }}
    >
      {title && (
        <div className="uni-overlay__header">
          <Headline level="3">{title}</Headline>
          <Dismiss size="large" className="uni-overlay__close" qaId="component-overlay-dismiss" onClick={onClose} />
        </div>
      )}
      {children}
    </ReactModal>
  );
};

Overlay.propTypes = {
  environment: PropTypes.oneOf(['light', 'dark']),
  isOpen: PropTypes.bool.isRequired,
  allowCloseOnOverlayClick: PropTypes.bool,
  allowCloseOnEsc: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  parentSelector: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  qaId: PropTypes.string,
  onAfterOpen: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/overlay/index.jsx